import { IPageTabNavLink } from "../interfaces-and-types";

export const settingsNavLinks: IPageTabNavLink[] = [
  {
    name: "Settings",
    route: "",
  },
];
